/**
 * Custom SVG markers for ArchiMate edges that need shapes React Flow's
 * built-in Arrow / ArrowClosed don't provide (filled diamond for
 * Composition, open diamond for Aggregation).
 *
 * Rendered once near the canvas; edges reference them by id via
 * `markerStart="url(#ae-composition)"`.
 */

export function EdgeMarkers() {
  return (
    <svg
      role="img"
      aria-label="ArchiMate edge marker definitions"
      style={{ position: "absolute", width: 0, height: 0 }}
    >
      <defs>
        {/* Diamonds render at the TARGET end (whole). refX=16 anchors the
            far tip of the diamond to the line endpoint so the shape extends
            backward into the line instead of into the target concept. */}
        <marker
          id="ae-composition"
          viewBox="0 0 16 12"
          refX="16"
          refY="6"
          markerWidth="14"
          markerHeight="10"
          orient="auto"
        >
          <path d="M 0 6 L 8 0 L 16 6 L 8 12 z" fill="#1e293b" stroke="#1e293b" strokeWidth="1" />
        </marker>
        <marker
          id="ae-aggregation"
          viewBox="0 0 16 12"
          refX="16"
          refY="6"
          markerWidth="14"
          markerHeight="10"
          orient="auto"
        >
          <path d="M 0 6 L 8 0 L 16 6 L 8 12 z" fill="white" stroke="#1e293b" strokeWidth="1.2" />
        </marker>
        <marker
          id="ae-assignment-dot"
          viewBox="0 0 8 8"
          refX="4"
          refY="4"
          markerWidth="8"
          markerHeight="8"
          orient="auto"
        >
          <circle cx="4" cy="4" r="3" fill="#475569" />
        </marker>
        {/* Half arrow (single upper stroke). Used for directed Association
            per ArchiMate 3.2: an undirected Association becomes directed by
            drawing a half-arrowhead at the target end. */}
        {/* Open (hollow) triangle at the TARGET end. Per ArchiMate 3.2 the
            Realization and Specialization relations both terminate in a
            hollow triangle; Realization adds a dotted line. */}
        <marker
          id="ae-open-triangle"
          viewBox="0 0 14 12"
          refX="13"
          refY="6"
          markerWidth="12"
          markerHeight="10"
          orient="auto"
        >
          <path d="M 1 1 L 13 6 L 1 11 z" fill="white" stroke="#1e293b" strokeWidth="1.2" />
        </marker>
        <marker
          id="ae-half-arrow"
          viewBox="0 0 12 10"
          refX="11"
          refY="5"
          markerWidth="14"
          markerHeight="12"
          orient="auto-start-reverse"
        >
          <path
            d="M 0 0 L 11 5"
            fill="none"
            stroke="#94a3b8"
            strokeWidth="1.4"
            strokeLinecap="round"
          />
        </marker>

        {/* ── Sharp ConceptAssociation crow's-foot-cardinaliteit ──────
             Vier symbolen per zijde, één-op-één met de enum-waarden uit
             registry/sharp-pack.json:
             - one          → dubbele dwarsstreep
             - zero_or_one  → enkele dwarsstreep + kleine open cirkel
             - one_or_many  → crow's-foot (drie lijntjes vanuit apex)
             - zero_or_many → crow's-foot + kleine open cirkel
             De viewBox is 0..18 horizontaal (lijnrichting), 0..16
             verticaal. refX=18 plaatst de fan-tips / verste streep AAN
             het lijneinde (entity-rand); de rest van het symbool zit
             terug langs de lijn. orient="auto-start-reverse" zorgt
             dat dezelfde marker zowel als markerEnd als markerStart
             juist georiënteerd verschijnt. */}
        {/* one (mandatory one) — twee parallelle dwarsstrepen. */}
        <marker
          id="ae-cf-one"
          viewBox="0 0 18 16"
          refX="18"
          refY="8"
          markerWidth="18"
          markerHeight="16"
          orient="auto-start-reverse"
        >
          <path
            d="M 9 2 L 9 14 M 14 2 L 14 14"
            fill="none"
            stroke="#94a3b8"
            strokeWidth="1.4"
            strokeLinecap="round"
          />
        </marker>
        {/* zero_or_one — enkele dwarsstreep (geen cirkel — Sharp-spec
             gebruikt voor 0..1 alleen één streep, niet de ER-conventie
             met cirkel). */}
        <marker
          id="ae-cf-zero-or-one"
          viewBox="0 0 18 16"
          refX="18"
          refY="8"
          markerWidth="18"
          markerHeight="16"
          orient="auto-start-reverse"
        >
          <path
            d="M 11 2 L 11 14"
            fill="none"
            stroke="#94a3b8"
            strokeWidth="1.4"
            strokeLinecap="round"
          />
        </marker>
        {/* one_or_many — crow's-foot zonder cirkel. Apex aan de lijn-
             zijde, drie lijntjes spreiden naar de entity-zijde. */}
        <marker
          id="ae-cf-one-or-many"
          viewBox="0 0 18 16"
          refX="18"
          refY="8"
          markerWidth="18"
          markerHeight="16"
          orient="auto-start-reverse"
        >
          <path
            d="M 2 8 L 18 2 M 2 8 L 18 8 M 2 8 L 18 14"
            fill="none"
            stroke="#94a3b8"
            strokeWidth="1.4"
            strokeLinecap="round"
          />
        </marker>
        {/* zero_or_many — crow's-foot + open cirkel. Cirkel ZIT VOOR
             de foot (verder van de entity). */}
        <marker
          id="ae-cf-zero-or-many"
          viewBox="0 0 22 16"
          refX="22"
          refY="8"
          markerWidth="22"
          markerHeight="16"
          orient="auto-start-reverse"
        >
          <circle cx="3" cy="8" r="2.5" fill="white" stroke="#94a3b8" strokeWidth="1.2" />
          <path
            d="M 7 8 L 22 2 M 7 8 L 22 8 M 7 8 L 22 14"
            fill="none"
            stroke="#94a3b8"
            strokeWidth="1.4"
            strokeLinecap="round"
          />
        </marker>
      </defs>
    </svg>
  );
}
